import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateTaskDto } from "@myapp/contract";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { rescheduleKeys } from "../../../reschedule/api/reschedule.keys";

export function useUpdateTask(id: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: UpdateTaskDto) =>
      taskApi.update(id, dto).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.count() });
    },
  });
}
